'use client'

import React, { useEffect, useMemo, useState } from 'react'

import { usePathname, useRouter } from 'next/navigation'

import {
  EventDetailsDescriptionSection,
  EventDetailsHeroSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { EventItem } from 'Types/emajinAPI'
import Utils from 'Utils'

import { EVENTS } from 'Constants/Paths'

import APIService from 'Services/API'

function EventsDetailsPage() {
  const pathname = usePathname()
  const router = useRouter()

  const [event, setEvent] = useState<EventItem | undefined>(undefined)
  const [loading, setLoading] = useState(false)

  const eventId = useMemo(
    () => Utils.Event.extractEventId(pathname),
    [pathname],
  )

  useEffect(() => {
    if (!eventId || event) return

    setLoading(true)

    APIService.getEvent(eventId)
      .then(result => {
        if (!result.data.event) {
          router.replace(EVENTS)
          return
        }

        setEvent(result.data.event)
      })
      .catch(() => {
        router.replace(EVENTS)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [event, eventId, router])

  return loading ? (
    <Column alignCenter fullWidth grow justifyCenter>
      <Loader inverse />
    </Column>
  ) : (
    <Column alignCenter fullWidth pt={[9, 9, 0]}>
      <EventDetailsHeroSection event={event} />

      <EventDetailsDescriptionSection
        data={event}
        pb={[13, 13, 13, 21]}
        pt={[9, 9, 9, 16]}
      />
    </Column>
  )
}

export default EventsDetailsPage
